declare const THREE: any;

const getScene = (): any => {
  const scene = new THREE.Scene();

  const whiteHex = 0xffffff;

  const intensity = 1;
  const ambientLight = new THREE.AmbientLight(whiteHex, intensity);
  ambientLight.name = 'amblight';
  scene.add(ambientLight);

  return scene;
};

export default getScene;
